module.exports = __webpack_public_path__ + "static/img/2_4_1.288655f0.jpg";